import React, { useEffect, useState } from "react";
import { useOutsideClick } from "../utils/useOutsideClick";
import { IoMdClose } from "react-icons/io";

export const Modal = ({ show, component, reference, size, onClose, outsideClickToClose }: IModal) => {
  const [visibile, setVisible] = useState(show);
  const [element, setElement] = useState(component);
  const [viewport, setViewport] = useState<string>();

  useEffect(() => {
    setVisible(show);
    setElement(component);
    setViewport(size)
  }, [show, component, size]);

  const content = useOutsideClick(() => {
    handleClose();
  });

  const handleClose = () => {
    setVisible(false);
    onClose?.();
  };

  return (
    <div
      ref={reference}
      className={`h-screen w-screen fixed top-0 left-0 bg-gray-900/70 backdrop-blur-sm place-content-center ${
        visibile ? "show scroll-hidden" : "hidden"
      }`}
    >
      <div className={`w-100 max-h-[90%] mx-auto ${viewport === 'sm' && 'sm:w-1/3 xl:w-2/5 2xl:w-1/5'}  ${viewport === 'md' || viewport === undefined && 'sm:w-2/3 xl:w-3/5 2xl:w-2/5'} ${viewport === 'lg' && 'sm:w-full xl:w-4/5 2xl:w-4/5'}`} ref={content}>
        <div className="container mx-auto">
          <IoMdClose className="text-white ms-auto cursor-pointer" size={32} onClick={handleClose} />
        </div>
        {visibile && element}
      </div>
    </div>
  );
};

export interface IModal {
  show?: boolean,
  component?: JSX.Element,
  reference?: React.MutableRefObject<any>,
  size?: 'sm' | 'md' | 'lg',
  onClose?: () => void,
  outsideClickToClose?: boolean,
  random?: string
}
